export function limitParagraph(text, size) {
  if (text?.length > size) {
    let shortText = text.substring(0, size);
    // Check if last character is a space, and remove it if not
    if (shortText[shortText.length - 1] !== ' ') {
      shortText = shortText.substring(0, shortText.lastIndexOf(' '));
    }
    return shortText + '...';
  } else {
    return text;
  }
}

export function getFirstFourWords(text) {
  const words = text?.split(' ');
  if (words?.length <= 4) {
    return text;
  } else {
    return words?.slice(0, 4).join(' ') + '...';
  }
}

export function getFirstTwoWords(text) {
  const words = text?.split(' ');
  if (words?.length <= 2) {
    return text;
  } else {
    return words?.slice(0, 2).join(' ') + '...';
  }
}
export function capitalizeFirstLetter(sentence) {
  if (!sentence) return sentence;
  return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase();
}

const LOWERCASE_JOINERS = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'by',
  'for',
  'in',
  'of',
  'on',
  'or',
  'the',
  'to',
  'with',
]);

/**
 * Display form of a task/response type. WordPress labels are already cased
 * ("Critical Response (Author and Authority)", "Document-Based Question (DBQ)"),
 * so each word only gains a capital first letter, found past any leading
 * bracket; the rest of the word is kept, and a lowercase joiner ("and", "of")
 * after the first word stays lowercase. Lowercasing every word's tail is what printed
 * "Critical Response (author And Authority)" and "(dbq)". Code-style values
 * ("EXTENDED_RESPONSE", "short_answer") are still turned into words.
 */
export const toTitleCase = (s) => {
  if (s == null) return '';
  const text = String(s);
  const isAllCapsCode = !/\p{Ll}/u.test(text) && /[\s_]/.test(text.trim());
  return (isAllCapsCode ? text.toLowerCase() : text)
    .split(/[\s_]+/)
    .filter(Boolean)
    .map((word, index) =>
      index > 0 && LOWERCASE_JOINERS.has(word)
        ? word
        : word.replace(/\p{L}/u, (letter) => letter.toUpperCase())
    )
    .join(' ');
};

export const isStringNull = (String) => {
  if (String === null || String === undefined) {
    return true;
  }
  return false;
};

export const formatYearDisplay = (v) => {
  const s = v != null ? String(v).trim() : '';
  if (!s || s.toLowerCase() === 'unassigned' || s.startsWith('Year ')) return s;
  return `Year ${v}`;
};

/**
 * Ends a fragment so another sentence can follow it.
 *
 * Counts written to stand alone ("12 of 30 ready") carry no full stop, so
 * anything appended to them runs the two together.
 */
export function endWithFullStop(text) {
  if (!text) return text;
  return /[.!?]$/.test(text.trim()) ? text : `${text}.`;
}
